<template>
    <VJoyHighlight level="info" display-icon icon="info-circle" class="joy-mt-2">
        {{ $t('search.global-matching.results-circles-hint') }}
    </VJoyHighlight>
</template>

<script setup lang="ts">
    import {VJoyHighlight} from '@maltjoy/core-vue';
</script>
